import React, { useEffect, useState } from 'react';
import * as Icon from 'react-feather';
import { Link } from 'react-router-dom';
import { LoopLogo } from './cartoon/Art';
import { buyLink, sectionLinks as links } from './cartoon/links';
import { itemCount, useCommerce } from '../commerce/CommerceContext';

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const { enabled, cart } = useCommerce();

    // Quando a pessoa rola a página, o menu fica preto (para destacar do conteúdo).
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const close = () => setOpen(false);

    return (
        <header className={`lc lc-nav${scrolled ? ' is-scrolled' : ''}`}>
            <div className="lc-wrap lc-nav-inner">
                <a href="#inicio" className="lc-nav-logo" onClick={close}>
                    <LoopLogo title="Loop Coffee, voltar ao início" />
                </a>

                <button
                    type="button"
                    className="lc-menu-btn"
                    aria-label={open ? 'Fechar menu' : 'Abrir menu'}
                    aria-expanded={open}
                    aria-controls="lc-menu"
                    onClick={() => setOpen(!open)}
                >
                    {open ? <Icon.X size={24} /> : <Icon.Menu size={24} />}
                </button>

                <nav aria-label="Menu principal">
                    <ul id="lc-menu" className={`lc-nav-links${open ? ' is-open' : ''}`}>
                        {links.map((link) => (
                            <li key={link.href}>
                                <a href={link.href} onClick={close}>{link.label}</a>
                            </li>
                        ))}
                        {enabled && (
                            <li>
                                <Link to="/checkout" onClick={close}>Carrinho ({itemCount(cart)})</Link>
                            </li>
                        )}
                        <li>
                            {enabled ? (
                                <a href="#bitbean" className="lc-btn" onClick={close}>Comprar</a>
                            ) : (
                                <a href={buyLink} target="_blank" rel="noopener noreferrer" className="lc-btn" onClick={close}>Comprar</a>
                            )}
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
}
